@if (isVisible) {
<div class="toast" [ngClass]="['toast--' + toastType, animationClass]" role="status" aria-live="polite">
  <fa-icon class="toast__icon" [icon]="toastIcon"></fa-icon>
  <div class="toast__content">
    @if (title) {
    <p class="toast__title">{{ title | translate }}</p>
    }
    <p class="toast__message">{{ message | translate }}</p>
  </div>
  <button type="button" class="toast__close" [attr.aria-label]="'CLOSE' | translate" (click)="close()">
    <fa-icon [icon]="faXmark"></fa-icon>
  </button>
</div>
}
